// extracted by mini-css-extract-plugin
export default {"dividerIcon":"FileDialog_dividerIcon__19nmy","dividerText":"FileDialog_dividerText__7px5A"};